module.exports = __webpack_public_path__ + "img/hearscope.3c3742b0.png";